import { ItemRecord } from '@controladad/ng-base';
import { TargetType } from '@models';

export const StatusValues: ItemRecord<number>[] = [
  { value: 1, label: 'Enabled' },
  { value: 0, label: 'Disabled' },
];

export const RoleValues: ItemRecord<number>[] = [
  { value: 0, label: 'Admin' },
  { value: 1, label: 'Vendor' },
  { value: 2, label: 'Customer' },
];

export const RoleItems: ItemRecord<number>[] = [
  { value: 0, label: 'Admin' },
  { value: 1, label: 'Vendor' },
  { value: 2, label: 'Customer' },
];

export const HouseTypeValues: ItemRecord<number>[] = [
  { value: 0, label: 'House' },
  { value: 1, label: 'Building' },
];

export const ProductTypeValues: ItemRecord<number>[] = [
  { value: 0, label: 'Simple' },
  { value: 1, label: 'Variable' },
  { value: 2, label: 'Bundle' },
];

export const ProductStatusValues: ItemRecord<number>[] = [
  { value: 0, label: 'Disable' },
  { value: 1, label: 'Enable' },
];

export const ProductApprovalValues: ItemRecord<number>[] = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'Approved' },
  { value: 2, label: 'Rejected' },
];

export const FeaturedValues: ItemRecord<boolean>[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const KeepTopValues: ItemRecord<boolean>[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const ReviewStatusValues: ItemRecord<number>[] = [
  { value: 0, label: 'Not Approved' },
  { value: 1, label: 'Approved' },
];

export const OrderStatusValues: ItemRecord<number>[] = [
  { value: 0, label: 'Pending Payment' },
  { value: 1, label: 'Pending' },
  { value: 2, label: 'Processing' },
  { value: 3, label: 'Ready' },
  { value: 4, label: 'Completed' },
  { value: 5, label: 'Cancelled' },
  { value: 6, label: 'Refunded' },
];

export enum Roles {
  admin,
  vendor,
  customer
}

export enum HouseType {
  House,
  Building
}

export const UserTypeValues: ItemRecord<string>[] = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'CUSTOMER', label: 'Customer' },
];

export const TransactionTypeValues: ItemRecord<number>[] = [
  { value: 0, label: 'Withdraw' },
  { value: 1, label: 'Deposit' },
];

export const PaymentMethodValues: ItemRecord<number>[] = [
  { value: 1, label: 'Cash' },
  { value: 2, label: 'PGW' },
  { value: 3, label: 'Wallet' },
];

export const WalletTransactionTypeValues: ItemRecord<number>[] = [
  { value: 0, label: 'Withdraw' },
  { value: 1, label: 'Deposit' },
];

export const WalletPaymentMethodValues: ItemRecord<number>[] = [
  { value: 1, label: 'Cash' },
  { value: 2, label: 'PGW' },
  { value: 3, label: 'Wallet' },
];

export const CouponTypeValues: ItemRecord<number>[] = [
  { value: 0, label: 'Fixed' },
  { value: 1, label: 'Percent' },
];

// Updated to match TargetType enum: Product: 0, Category: 1, Customer: 2, Vendor: 3, Shipping: 4, CartItem: 5
export const DiscountForValues: ItemRecord<TargetType>[] = [
  { value: TargetType.Product, label: 'Products' },
  { value: TargetType.Category, label: 'Categories' },
  { value: TargetType.Customer, label: 'Customers' },
  { value: TargetType.Vendor, label: 'Vendors' },
  { value: TargetType.CartItem, label: 'Cart Items' },
];

export const OrderItemStatusValues: ItemRecord<number>[] = [
  { value: 0, label: 'InProgress' },
  { value: 1, label: 'Ready' },
  { value: 2, label: 'Cancelled' },
]
